export default __webpack_public_path__ + "static/media/az.4e15c126.svg";